module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0128.jpg?v=c2cb0d1d";